module.exports = __webpack_public_path__ + "static/Avion-3ef914f81076880e7678d3ea4e71bb57.jpg";